import * as React from 'react';
import { Radio, UIHeading3, UIText2 } from '@cian/ui-kit';

import * as styles from './RegionColumns.css';
import { TLocationModalStep } from '../../../../types/locationModal';
import { IRegion } from '../../../../types/regions';

interface IRegionColumnsProps {
  regionColumns: IRegion[][][];
  step: TLocationModalStep;
  currentRegion: IRegion;
  onRegionClick: (region: IRegion) => void;
}

export const RegionColumns: React.FC<IRegionColumnsProps> = ({ regionColumns, step, currentRegion, onRegionClick }) => {
  return (
    <div className={styles['container']}>
      {regionColumns.map((column, index) => (
        <div key={`column-${index}`} className={styles['columns']}>
          {column.map((regionArray, columnIndex) => (
            <div key={columnIndex}>
              <UIHeading3>{regionArray[0].name[0]}</UIHeading3>
              <div className={styles['column-regions']}>
                {regionArray.map((region: IRegion) => (
                  <div key={region.id} className={styles['region']}>
                    {step === 'cities' ? (
                      <Radio
                        label={region.name}
                        onChange={() => onRegionClick(region)}
                        checked={region.id === currentRegion.id}
                        value={String(region.id)}
                        name="city"
                      />
                    ) : (
                      <div className={styles['clickable-text']} onClick={() => onRegionClick(region)}>
                        <UIText2 color="current_color">{region.name}</UIText2>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
